import React, { FC } from 'react';

import { Box, Flex } from '@adsk/alloy-react-box';
import ContentLoader from '@adsk/alloy-react-content-loader';
import theme from '@adsk/alloy-react-theme';

export const TopNavigationLayoutLoader: FC = ({ children }) => (
  <Flex
    height="100vh"
    width="100vw"
    flexDirection="column"
    data-testid="TopNavigationLayoutLoader"
  >
    <Box
      width="100%"
      minHeight={theme.spacing.large}
      backgroundColor={theme.colors.black}
    />
    <Flex
      width="100%"
      height={48}
      backgroundColor={theme.colors.white}
      border={`1px solid ${theme.colors.charcoal300}`}
      paddingY={`${theme.spacing.XS}px`}
      paddingRight={`${theme.spacing.M}px}`}
      paddingLeft={`${theme.spacing.XS}px`}
      alignItems="center"
      justifyContent="space-between"
    >
      <ContentLoader
        height={33}
        width={227}
        backgroundColor={theme.colors.charcoal200}
      >
        <rect height="16" rx="8" ry="8" width="104" x="40" y="10" />
        <rect height="33" rx="9" ry="9" width="32" x="0" y="0" />
      </ContentLoader>
      <Box flex={1}>
        <ContentLoader height="33px" backgroundColor={theme.colors.charcoal200}>
          <rect height="16" rx="8" ry="8" width="193" x="40" y="10" />
          <rect height="33" rx="9" ry="9" width="32" x="0" y="0" />
        </ContentLoader>
      </Box>
      <Flex
        width="79px"
        justifyContent="space-between"
        alignItems="center"
        margin={`0 ${theme.spacing.medium}px`}
      >
        <Box
          width={15}
          height={15}
          backgroundColor={theme.colors.charcoal600}
          borderRadius="50%"
        />
        <Box
          width={25}
          height={25}
          backgroundColor={theme.colors.charcoal200}
          borderRadius="50%"
        />
      </Flex>
    </Flex>
    <Flex flex={1}>{children}</Flex>
  </Flex>
);
